import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { ExtraMessageWithBlurredBg } from '@sorare/core/src/components/onboarding/ExtraMessageWithBlurredBg';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Footer = styled.div`
  position: absolute;
  bottom: var(--double-unit);
  left: var(--double-unit);
  right: var(--double-unit);

  @media ${tabletAndAbove} {
    visibility: hidden;
  }
`;
const Message = styled(ExtraMessageWithBlurredBg)`
  backdrop-filter: blur(20px);

  @media ${tabletAndAbove} {
    max-width: calc(40 * var(--unit));
  }
`;

type Props = { onClose: () => void };
export const InfoIconTutorial = ({ onClose }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();

  return (
    <HighlightOverlay
      highlightNames={['MarketInfoIcon']}
      onClose={onClose}
      extras={[
        {
          nextTo: 'MarketInfoIcon',
          render: props => (
            <>
              <Message
                align="center"
                anchor="bottom"
                positionProps={props}
                fullWidth={!isTabletAndAbove}
              >
                <LabelL>
                  <FormattedMessage defaultMessage="Tap this icon if you want to view the tutorial videos again." />
                </LabelL>
              </Message>
              <Footer>
                <Button onClick={onClose} fullWidth size="large">
                  <FormattedMessage {...glossary.gotIt} />
                </Button>
              </Footer>
            </>
          ),
        },
      ]}
    />
  );
};
